/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NewMessageAction/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import ButtonIcon from 'DesignSystem/ButtonIcon/index'
import PlusIcon from 'DesignSystem/Svgs/PlusIcon/index'
import React from 'react'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function NewMessageAction({
  children,
  viewPath = "/App/Account/Content/Comms/Topbar/NewMessageAction"
  
}) {
  let isMedia = useIsMedia()
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<fromFlow.When is={!isMedia.mobile}>
<ButtonIcon
  viewPath={`${viewPath}/ButtonIcon`}
 marginRight={8}
 onClick={() => setFlowTo("/App/Account/Search/Content")}
 isSelected={flow.has("/App/Account/Search/Content")}
>
{childProps => (
<PlusIcon
{...childProps}
  viewPath={`${viewPath}/PlusIcon`}
 width={16}
 height={16}
 stroke="rgba(0,0,0,0.7)"
/>
)}
</ButtonIcon>
</fromFlow.When>
{children}
</React.Fragment>)
}